import React, { useState } from 'react'
import _ from 'lodash'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tabs, Tab, Button } from '@material-ui/core'
import FixtureCard from '../FixtureCard'
import SectionHeader from '../SectionHeader'
import Icons from '../Icons'
import EmptyState from '../EmptyState'
import { useInplayPostdata } from '../../hooks/use-inplaypost-data'

const InplaySection = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const InplayHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`
const InplayTabs = styled(Tabs)`
  background: transparent;
`
const SectionButton = styled(Button)`
  margin: ${props => props.theme.spacing(6)}px
    ${props => props.theme.spacing(0)}px ${props => props.theme.spacing(2)}px
    ${props => props.theme.spacing(0)}px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.12),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.2);
`

const InplayFixtures = ({ data, page }) => {
  // Local state
  // value is the selected sport (via tabs change)
  const [value, setValue] = useState(0)

  const items = useInplayPostdata()

  const nodes = data.map(node => node)
  const status = nodes.filter(item => item.node.status === 'inplay')
  const statusCount = status.length

  // Create a unique list of sports
  const inplaySports = _.uniq(
    Object.keys(items).map(key => items[key].node.sport)
  )

  // handleChange as per MUI docs example
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const inplaySport = inplaySports[value]

  if (page === 'home') {
    return (
      <InplaySection>
        <InplayHeader>
          <SectionHeader icon="live" title="In Play" />
          <InplayTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
          >
            {inplaySports.map((sport, key) => (
              <Tab
                key={key}
                icon={
                  <Icons
                    icon={sport}
                    style={{
                      fontSize: 24,
                      marginBottom: '6px',
                    }}
                  />
                }
                aria-label={sport}
                style={{ width: '72px', minWidth: '72px' }}
              />
            ))}
          </InplayTabs>
        </InplayHeader>
        {items.map(({ node }) => {
          if (node.status === 'inplay' && node.sport === inplaySport) {
            return (
              <FixtureCard
                key={`${node.status}-${node.id}`}
                fixture={node}
                inplay
                subheader
                court="display"
              />
            )
          }
          return null
        })}
        <SectionButton
          component={Link}
          variant="contained"
          color="secondary"
          to="/in-play"
        >
          All {inplaySport} Markets
        </SectionButton>
      </InplaySection>
    )
  }
  // if (statusCount === 0) {
  //   return (
  //     <EmptyState
  //       key="inplay"
  //       section="inplay"
  //       title="Inplay Markets"
  //       text="Currently no inplay markets available"
  //     />
  //   )
  // }
  return data.map(({ node }) => {
    if (node.status === 'inplay') {
      return <FixtureCard key={`${node.id}`} fixture={node} subheader inplay />
    }
    return null
  })
}

InplayFixtures.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.string,
}

export default InplayFixtures
